import * as React from "react"
import {IconSeeker} from "@ui-seeker/core";
import {Box} from "@mui/material";


export default function countriesMatchColumn() {
    return [{
        name: 'countriesMatch', label: 'Countries Match',
        options: {
            display: 'excluded',
            customBodyRowRender: (value, dataRow) => {
                if (value === null)
                    return 'N/A'
                return value ? 'Yes' : 'No'
            }
        }
    },{
        name: 'countriesMatch', label: 'Countries Match',
        options: {
            filter: false,
            setCellHeaderProps: () => ({ sx: {
                    whiteSpace: 'pre-wrap',
                    minWidth: 160
                }}),
            customBodyRowRender: (value) => {
                let color = 'text.disabled'
                let icon = 'square-minus'

                if (value !== null) {
                    color = value ? 'success.lighter' : 'error.lighter'
                    icon = value ? 'square-check' : 'square-xmark'
                }

                return <Box sx={{ textAlign: 'center', fontSize: 21 }}>
                    <IconSeeker icon={icon} sx={{ color: color }}/>
                </Box>}
        }
    }]
}